module.exports = __webpack_public_path__ + "static/img/locations1.209b5ee8.png";